<template>
  <div class="ui-kit-v2-tag" @click="focusInput">
    <div class="ui-kit-v2-tag__hash">#</div>
    <div class="ui-kit-v2-tag__content">
      <div class="ui-kit-v2-tag__content__text">
        <input
          ref="input"
          :disabled="!editable"
          :value="value.name"
          :size="value.name.length + 1"
          type="text"
          @input="input"
          @blur="saveTag"
        />
      </div>
      <div class="ui-kit-v2-tag__content__icon--close" @click="deleteTag">
        <Icon icon="close" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tag',
  props: {
    index: {
      type: Number,
      default: 0
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    editable() {
      return !this.value.id;
    }
  },
  methods: {
    input(event) {
      this.$emit('input', event.target.value);
    },
    deleteTag() {
      this.$emit('delete');
    },
    saveTag() {
      if (this.editable) {
        this.$emit('save');
      }
    },
    focusInput() {
      this.$refs.input?.focus();
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/style/utils';

.ui-kit-v2-tag {
  background: $main-bg;
  min-height: 32px;

  &__hash {
    margin-right: 4px;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    user-select: none;
  }

  &__content {
    display: flex;
    align-items: center;
    cursor: text;

    &__text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 16px;
      line-height: 20px;

      input {
        @include uiFont;
        background: transparent;
        border: none;
        font-size: 16px;
        line-height: 20px;
      }
    }

    &__icon {
      &--close {
        cursor: pointer;
        svg {
          width: 10px;
          height: 10px;
          fill: #ceced6;
        }
      }
    }
  }
}
</style>
